import { HttpErrorResponse } from "@angular/common/http";
import { Component } from "@angular/core";
import { NavParams, ViewController } from "ionic-angular";
import { OrderBase } from "models/order-management/orderBase";
import { OrderSearchRequest } from "models/order-management/orderSearchRequest";
import { OrderManagementDataService } from "providers/order-management-data-service/order-management-data-service";
import { UtilityService } from "providers/utility-service/utility-service";

interface ActiveMedication {
  orderId: string;
  orderType: string;
  nameDescription: string;
  prescriptionDrugFormat: string;
}

const PAGE_SIZE: number = 100;

@Component({
  selector: "active-medications-popover",
  templateUrl: "active-medications-popover.html",
})
export class ActiveMedicationsPopover {
  patientChartId: number;
  activeMedications: Array<ActiveMedication> = [];
  orderSearchDetails: OrderSearchRequest = null;
  loadMedications: boolean = false;

  constructor(
    public navParams: NavParams,
    private utilService: UtilityService,
    private orderManagementDataService: OrderManagementDataService,
    public viewCtrl: ViewController
  ) {
    this.patientChartId = this.navParams.get("patientChartId");
    this.loadActiveMedications();
  }

  closeModal() {
    this.viewCtrl.dismiss({ cancel: true });
  }

  loadActiveMedications() {
    this.utilService.increaseSpinnerCount("Loading Medications ...");
    this.loadMedications = true;
    this.getActiveMedications();
  }

  getActiveMedications() {
    this.createSearchRequestBody();
    this.orderManagementDataService
      .searchOrders(this.orderSearchDetails)
      .finally(() => {
        this.loadMedications = false;
        this.utilService.decreaseSpinnerCount();
      })
      .subscribe(
        (OpenSearchResponse) => {
          if (OpenSearchResponse && OpenSearchResponse.hits) {
            let newActiveMedications = OpenSearchResponse.hits.map((order) => ({
              orderId: order.orderId,
              orderType: order.orderSubtype
                ? "Medication - " +
                  OrderBase.orderSubtypeDisplay(order.orderSubtype)
                : "Medication",
              nameDescription: order.nameDescription,
              prescriptionDrugFormat: order.prescriptionDrugFormat
                ? order.prescriptionDrugFormat
                : order.nonERXAdministrationFormat,
            }));
            this.activeMedications = newActiveMedications;
          } else {
            this.activeMedications = [];
          }
        },
        (err: HttpErrorResponse) =>
          console.error("Error loading Active Medications. ", err)
      );
  }

  createSearchRequestBody() {
    let details: OrderSearchRequest = {
      patientChartId: this.patientChartId,
      orderType: "MEDICATION",
      from: 0,
      size: PAGE_SIZE,
      sortBy: {
        name: "nameDescription",
        value: "asc",
      },
      includeDiscontinued: false,
    };
    this.orderSearchDetails = details;
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/active-medications-popover/active-medications-popover.ts